<template>
  <div>
    <div class="right-box">
      <div class="right-title">
        <span>热门公司</span>
         <a href="/enterprise/#/list?field=全部&category=全部" target="_blank">更多</a>
      </div>
      <ul class="platform">
        <li><a href="http://www.100ec.cn/Index/wjs_search_res.html?kw=文心一言" target="_blank">文心一言</a></li>
        <li><a href="http://www.100ec.cn/Index/wjs_search_res.html?kw=通义千问" target="_blank">通义千问 </a></li>
        <li><a href="http://www.100ec.cn/Index/wjs_search_res.html?kw=Kimi" target="_blank">Kimi</a></li>
        <li><a href="http://www.100ec.cn/Index/wjs_search_res.html?kw=ChatGPT" target="_blank">ChatGPT</a></li>
        <li><a href="http://www.100ec.cn/Index/wjs_search_res.html?kw=DeepSeek" target="_blank">DeepSeek</a></li>
        <li><a href="http://www.100ec.cn/Index/wjs_search_res.html?kw=元宝" target="_blank">元宝</a></li>
        <li><a href="http://www.100ec.cn/Index/wjs_search_res.html?kw=松鼠 ai" target="_blank">松鼠AI</a></li>
      </ul>
      <!-- <Company /> -->
    </div>

    <div class="right-box">
      <div class="right-title">
        <span>AI人物</span>
         <a href="/Index/wjs_search_res.html?kw=AI" target="_blank">更多</a>
      </div>
      <!-- 易纲 尚福林 郭树清 易会满 井贤栋 罗敏 张俊 唐宁 孙陶然 周晔 -->
      <ul class="platform">
        <li><a href="//www.100ec.cn/Index/wjs_search_res.html?kw=李彦宏" target="_blank">李彦宏</a></li>
        <li><a href="//www.100ec.cn/Index/wjs_search_res.html?kw=马化腾 ai" target="_blank">马化腾</a></li>
        <li><a href="//www.100ec.cn/Index/wjs_search_res.html?kw=马云 AI" target="_blank">马云</a></li>
        <li><a href="//www.100ec.cn/Index/wjs_search_res.html?kw=周鸿祎 人工智能" target="_blank">周鸿祎</a></li>
        <li><a href="//www.100ec.cn/Index/wjs_search_res.html?kw=张一鸣" target="_blank">张一鸣</a></li>
        <li><a href="//www.100ec.cn/Index/wjs_search_res.html?kw=张鹏" target="_blank">张鹏</a></li>
      </ul>
      <!-- <ul class="platform">
        <li v-for="(text,index) of renwu" :key="index"><a href="http://www.100ec.cn/Index/wjs_search_res.html?kw='text'"></a>{{text}}</li>
      </ul> -->
    </div>
    <div class="right-box">
      <div class="right-title">
        <span>AI专家</span>
         <a href="/Index/wjs_search_res.html?kw=AI" target="_blank">更多</a>
      </div>
      <!-- 易纲 尚福林 郭树清 易会满 井贤栋 罗敏 张俊 唐宁 孙陶然 周晔 -->
      <ul class="platform">
        <li><a href="//www.100ec.cn/Index/wjs_search_res.html?kw=曹磊 AI" target="_blank">曹磊</a></li>
        <li><a href="//www.100ec.cn/Index/wjs_search_res.html?kw=陈礼腾 AI" target="_blank">陈礼腾</a></li>
        <li><a href="//www.100ec.cn/Index/wjs_search_res.html?kw=郭涛 AI" target="_blank">郭涛</a></li>
        <li><a href="//www.100ec.cn/Index/wjs_search_res.html?kw=郑吉昌 AI" target="_blank">郑吉昌</a></li>
      </ul>
      <!-- <ul class="platform">
        <li v-for="(text,index) of renwu" :key="index"><a href="http://www.100ec.cn/Index/wjs_search_res.html?kw='text'"></a>{{text}}</li>
      </ul> -->
    </div>
    <!-- <div style="width: 365px">
        <a href="https://www.100ec.cn/zt/wswjsxfpgyl/" target="_blank">
          <img style="width: 100%" src="/Public/home/images/zyttk/xfpjr1.jpg" />
        </a>
      </div> -->
    <Email />
    <!-- <div class="right-box">
      <div class="right-title">
        <span>热门投诉</span>
        <a href="/Index/complain.html" target="_blank">我要投诉</a>
      </div>

      <ul class="platform">
        <li
          v-for="(i, index) of platform"
          :key="index"
          @click="getPlatform(index)"
        >
          {{ i }}
          <i class="fa fa-fire fa-lg"></i>
        </li>
      </ul>
    </div> -->
    <div class="right-box" style="padding: 0px;">
      <a href="/detail--6657650.html" target="_blank">
        <img src="//www.100ec.cn/Public/tuku/69cb39ddf1434.jpg" style="width: 100%; margin: 0 auto;height:1740px"/>
      </a>
    </div>
    <!-- <div class="right-box">
      <div class="right-title">
        <span>图书推荐</span>
      </div>

      <a
        href="http://www.100ec.cn/zt/hlwhpjr/"
        target="_blank"
      >
        <img
          src="/Public/Upload/hlwphjr.jpg"
          style="width: 80%; margin: 0 auto 20px"
        />
      </a>
      
    </div> -->
        
  </div>
</template>
<script>
export default {
  name: "ContentR",
  data() {
    return {
      params: {
        field: "金融科技",
        tabs: ["数字金融", "保险", "银行", "征信", "支付"],
      },
      year: "",
      time: "",
      platform: [],
      // renwu:["易纲", "尚福林", "郭树清", "易会满", "井贤栋", "罗敏", "张俊", "唐宁", "孙陶然", "周晔","肖文杰", "赵国庆", "沈鹏", "杨一夫", "计葵生", "叶大清", "周世平", "董骏","陈宝国", "郭宇航", "姚宏", "曹磊", "张周平", "莫岱青", "黄震", "叶檀", "余丰慧"]
    };
  },
  created() {
    this.$store.commit("getCompanyTabs", this.params);
  },
  mounted() {
    if (new Date().getMonth >= 2) {
      this.year = new Date().getFullYear();
    } else {
      this.year = new Date().getFullYear() - 1;
      this.time = "whole_year";
    }
    axios
      .get(
        "https://www.100ec.cn/315/api/index.php?_a=product&f=most_company_list&type=77"+
          "&limit=20&year=" +
          this.year +
          "&time=" +
          this.time
      )
      .then((res) => {
        for (var i of res.data.list) {
          this.platform.push(i.company);
        }
      });
  },
  methods: {
    getPlatform(index) {
      window.open(
        "/Index/complain_search.html?company=" + this.platform[index]
      );
    },
  },
};
</script>
<style scoped>
.platform a{
    color: #606266;
}
</style>